import React from 'react';
import Button from '@ui/Button';
import Typography from '@ui/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    '& .MuiButton-label': {
      width: 'unset',
    },
  },
  open: {
    opacity: 1,
  },
}));

export interface CounterButtonProps {
  open: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  productUsage?: {
    limit: number | string;
    usage: number | string;
  };
}

const CounterButton = React.forwardRef<HTMLButtonElement, CounterButtonProps>(
  (props, forwardRef) => {
    const { open, onClick, productUsage } = props;

    const { classes, cx } = useStyles();

    const meteredLimit = productUsage?.limit || 0;
    const meteredUsage = productUsage?.usage || 0;

    return (
      <Button
        variant="compact"
        className={cx(classes.container, { [classes.open]: open })}
        data-e2e={'wsl-counter-button'}
        buttonStyle="pill"
        onClick={onClick}
        ref={forwardRef}
        tabIndex={0}
      >
        <Typography variant="pSm" color="secondary" inline>
          <Typography variant="pSm" bold inline>
            {meteredUsage}
          </Typography>{' '}
          <Typography
            variant="pSm"
            color="secondary"
            bold
            inline
          >{`/ ${meteredLimit}`}</Typography>
          {' download minutes used'}
        </Typography>
      </Button>
    );
  }
);

export default CounterButton;
